import React from 'react';
import { Box, Container, Typography, Link, Grid } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Typography variant="h6" gutterBottom>
              Anılar Bulutta
            </Typography>
            <Typography variant="body2">
              Etkinliklerinizin anılarını güvenle saklayın ve paylaşın
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Typography variant="h6" color="text.primary" gutterBottom>
              Bağlantılar
            </Typography>
            <Typography variant="body2">
              <Link component={RouterLink} to="/" color="inherit" sx={{ mx: 1 }}>
                Ana Sayfa
              </Link>
              <Link component={RouterLink} to="/login" color="inherit" sx={{ mx: 1 }}>
                Giriş
              </Link>
            </Typography>
          </Grid>

          <Grid item xs={12} md={4} textAlign="center">
            <Typography variant="h6" color="text.primary" gutterBottom>
              Yasal
            </Typography>
            <Typography variant="body2">
              <>
                <Link component={RouterLink} to="/privacy" color="inherit" sx={{ mx: 1 }}>
                  Gizlilik Politikası
                </Link>
                <a href="/privacy" style={{ display: 'none' }}>Privacy</a>
              </>
              <Link component={RouterLink} to="/terms" color="inherit" sx={{ mx: 1 }}>
                Kullanım Koşulları
              </Link>
            </Typography>
          </Grid>
        </Grid>

        <Typography variant="body2" align="center" sx={{ mt: 3 }}>
          © {new Date().getFullYear()} Anılar Bulutta. Tüm hakları saklıdır.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;